import React, { useState } from 'react';
import { Brain, X } from 'lucide-react';
import AIChatWidget from '@/pages/AIChatWidget';

const FloatingAIButton = () => {
  const [showWidget, setShowWidget] = useState(false);

  return (
    <>
      {/* Floating Button */}
      {!showWidget && (
        <button
          onClick={() => setShowWidget(true)}
          className="fixed bottom-6 right-6 w-14 h-14 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all hover:scale-110 active:scale-95 flex items-center justify-center group"
          style={{ zIndex: 9999 }}
          aria-label="Open AI Assistant"
        >
          <Brain size={24} className="group-hover:animate-pulse" />
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-ping"></span>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full"></span>
        </button>
      )}

      {/* AI Chat Widget */}
      {showWidget && (
        <div className="fixed bottom-6 right-6 shadow-2xl" style={{ zIndex: 9999 }}>
          <AIChatWidget 
            standalone={false}
            onClose={() => setShowWidget(false)}
          />
        </div>
      )}
    </>
  );
};

export default FloatingAIButton;
